import React, { useState } from 'react'
import { InputField, ToggleField } from 'components/molecules'
import { Button, Card } from 'reactstrap'
import PropTypes from 'prop-types'
import { NOTIFICATION_PROVIDERS, BUTTON_OPTIONS } from 'domains/announcements/constants'
import StringUtil from 'utils/string-util'
import { TitlePage } from 'components/atoms'
import { FieldArray } from 'formik'

const propTypes = {
  formikBag           : PropTypes.object.isRequired,
  hasWhatsapp         : PropTypes.bool,
  onChangeHasWhatsapp : PropTypes.func
}

const sectionInitialValue = { text: '' }

const WhatsappTemplateForm = ({
  hasWhatsapp,
  onChangeHasWhatsapp,
  formikBag
}) => {
  const [ provider, setProvider ] = useState('')

  const createWhatsappButtonText = hasWhatsapp ? 'Remove Whatsapp' : 'Add Whatsapp'
  const updateWhatsappButtonText = hasWhatsapp ? 'Hide Whatsapp' : 'Add Whatsapp'
  const whatsappButtonText       = formikBag?.values?.id ? updateWhatsappButtonText : createWhatsappButtonText

  const whatsappButtonColor = hasWhatsapp ?  'danger' : 'success'

  const handleChangeProvider = (event, formikBag) => {
    setProvider(event.target.value)
    formikBag.handleChange(event)
    if (event.target.value !== NOTIFICATION_PROVIDERS.FRESHCHAT.value) {
      formikBag.setFieldValue('whatsapp.namespace', '')
    }
  }

  const handleCopyTextValue = (value) => {
    navigator.clipboard.writeText(value)
    alert('Text copied')
  }

  // eslint-disable-next-line react/prop-types
  const TextFieldFormText = ({ textValue }) => {
    const providerName = NOTIFICATION_PROVIDERS[provider?.toUpperCase()]?.name
    return (
      <>
        <Button
          size='sm'
          color='primary'
          className='mb-3'
          onClick={ () => handleCopyTextValue(textValue) }
        >
          <span>
            { 'Copy' }
            <i className='fas fa-copy ml-3' />
          </span>
        </Button>
        <br />
        {
          provider &&
          (
            <>
              <strong>{ 'Peringatan!' }</strong>
              <br />
              { 'Perhatikan hal-hal berikut saat mengisi field Text:' }
              <br />
              <ul>
                <li>
                  { 'Pastikan konten yang kamu masukan ke field ' }
                  <strong>{ 'Text' }</strong>
                  { ' sama dengan yang akan didaftarkan pada template twillio agar pengiriman pesan nanti tidak gagal.' }
                </li>
                <li>
                  { 'Pastikan saat mengisi field ' }``
                  <strong>{ 'Text' }</strong>
                  { ' tidak ada extra spasi diakhir kalimat.' }
                </li>
                <li>
                  { 'Setelah template terbuat mohon untuk mendaftarkan template tersebut ke ' }
                  <strong>{ `${providerName}.` }</strong>
                </li>
                <li>
                  { 'Kamu dapat mengecek/mendaftarkan template yang ada di ' }
                  <strong>{ `${providerName}` }</strong>
                  { ' dengan menekan tombol yang ada di kiri bawah.' }
                </li>
              </ul>
            </>
          )
        }
      </>
    )
  }
  return (
    <>
      <div className='d-flex justify-content-between'>
        <TitlePage mainTitle={ 'Whatsapp' } />
        <Button
          size="sm"
          color={ whatsappButtonColor }
          onClick={ () => onChangeHasWhatsapp(!hasWhatsapp) }
        >
          { whatsappButtonText }
        </Button>
      </div>

      { hasWhatsapp &&
        (
          <>
            <InputField
              type='text'
              name='whatsapp.name'
              label='name'
              required={ true }
              formText={ <>
                <strong>{ 'No space character allowed: ' }</strong>{ 'Mohon untuk tidak menggunakan spasi dan karakter spesial (semimsal _, *, &, $) untuk nama template whatsapp' }
                <br />
                <strong>{ 'Should same as Meta/ Freshchat template name: ' }</strong>{ 'Agar pesan whatsapp terkirim, tolong periksa kembali kesamaan nama template whatsapp' }
                <br />
                { 'antara di ops-dashboard dan di Meta/ Freshchat template dashboard' }
              </> }
            />

            <InputField
              type='select'
              name='whatsapp.provider'
              label='Provider'
              required={ true }
              onChange={ (event) => handleChangeProvider(event, formikBag) }
              formText={ <>
                <strong>{ 'Meta: ' }</strong>{ 'Silahkan menggunakan nomor whatsapp Tinkerlust Deals dalam membuat template, untuk provider Meta.' }
                <br />
                <strong>{ 'Freshchat: ' }</strong>{ 'CS Freshchat nomor whatsapp adalah untuk provider Freshchat.' }
                <br />
                <strong>{ 'Language: ' }</strong>{ 'dimohon untuk selalu memilih Bahasa Indonesia (ID) dalam membuat template di kedua provider (Meta dan Freshchat).' }
              </> }
            >
              <option key='' value=''>Choose one</option>
              {
                Object.keys(NOTIFICATION_PROVIDERS).map((key) => {
                  const option     = NOTIFICATION_PROVIDERS[key].name
                  const value      = NOTIFICATION_PROVIDERS[key].value
                  const isDisabled = NOTIFICATION_PROVIDERS[key].disabled
                  return (
                    <option
                      key={ `notification-channel-${option}` }
                      value={ value }
                      disabled={ isDisabled }
                    >
                      { StringUtil.titleCase(option) }
                    </option>
                  )
                })
              }
            </InputField>
            {

              provider == NOTIFICATION_PROVIDERS.FRESHCHAT.value && (
                <InputField
                  type='text'
                  name='whatsapp.namespace'
                  label='Namespace'
                  required={ true }
                />
              )
            }

            <InputField
              type='textarea'
              name='whatsapp.body'
              rows='5'
              label='Body'
              formText={ <TextFieldFormText textValue={ formikBag.values.body } /> }
              required={ true }
            />

            {
              formikBag.values.whatsapp.provider == NOTIFICATION_PROVIDERS.META.value &&
            (
              <>
                <ToggleField
                  id={ 'whatsapp.has_image' }
                  name={ 'whatsapp.has_image' }
                  label={ 'Has Image?' }
                  formText={ <>
                    <strong>{ 'Yes: ' }</strong>{ 'Jika template meta memiliki image mohon untuk membuatnya dari meta dashboard setelah membuat disini' }
                    <br />
                    <strong>{ 'No: ' }</strong>{ 'Membuat template disini' }
                    <br />
                    <strong>{ 'Format & Size: ' }</strong>{ 'Mohon gunakan image format .JPG atau .PNG dengan ukuran/ size ratio persegi 1:1 atau persegi panjang 16:9. Contoh size 1125px by 600px.' }
                    <br />
                    <strong>{ 'Sample URL: ' }</strong>{ 'https://media.karousell.com/media/photos/products/2021/7/17/gucci_speedy_waterproof_sz_33x_1626560510_bfb97962_progressive.jpg' }
                    <br />
                    <strong>{ 'Docs Link: ' }</strong>{ 'https://www.delightchat.io/help-center/whatsapp-template-message-image-size' }
                  </> }
                />
                {
                  formikBag.values.whatsapp.has_image &&
                  (
                    <InputField
                      type='text'
                      name='whatsapp.header'
                      label='Image Url'
                      required={ true }
                    ></InputField>
                  )
                }

                <FieldArray name={ 'whatsapp.buttons' }>
                  {
                    ({ remove, push }) => (
                      <>
                        {
                          formikBag.values.whatsapp.buttons.map((button, index) => (
                            <Card
                              key={ `button-field-array${button?.id}` }
                              body
                            >

                              <InputField
                                type='select'
                                name={ `whatsapp.buttons[${index}].event_type` }
                                label='Button Type'
                                required={ true }
                                onChange={ (event) => handleChangeProvider(event, formikBag) }
                              >
                                <option key='' value=''>Choose one</option>
                                {
                                  Object.keys(BUTTON_OPTIONS).map((key) => {
                                    const option     = BUTTON_OPTIONS[key].name
                                    const value      = BUTTON_OPTIONS[key].value
                                    const isDisabled = BUTTON_OPTIONS[key].disabled
                                    return (
                                      <option
                                        key={ `notification-channel-${option}` }
                                        value={ value }
                                        disabled={ isDisabled }
                                      >
                                        { StringUtil.titleCase(option) }
                                      </option>
                                    )
                                  })
                                }
                              </InputField>

                              <InputField
                                type='text'
                                label={ `Button Name ${index + 1}` }
                                placeholder='Call Center'
                                name={ `whatsapp.buttons[${index}].text` }
                                required={ false }
                              />

                              <InputField
                                type='text'
                                label={ `Button Action ${index + 1}` }
                                placeholder='link / phone number'
                                name={ `whatsapp.buttons[${index}].event_value` }
                                required={ false }
                              />

                              <Button
                                className='mb-4'
                                color='danger'
                                onClick={ () => remove(index) }
                              >
                                { 'Remove button' }
                              </Button>
                            </Card>
                          ))
                        }

                        {
                          formikBag.values.whatsapp.buttons.length < 2 &&
                      (
                        <Button
                          color='success'
                          className='my-5'
                          onClick={ () => push(sectionInitialValue)  }
                        >
                          { 'Add New button' }
                        </Button>
                      )
                        }
                      </>
                    ) }
                </FieldArray>
              </>
            )
            }
          </>
        )
      }
    </>
  )
}

WhatsappTemplateForm.propTypes = propTypes

export default WhatsappTemplateForm
